export default __webpack_public_path__ + "static/media/home_thumb_4s.08b86738.png";